import {
  EllipsisWithTooltip,
  Skeleton,
  Typography,
  Stack,
} from '@cast/design-system';

import { CopyToClipboard } from 'components/clickable-actions';

type Props = {
  title: React.ReactNode;
  detail?: React.ReactNode;
  showCopy?: boolean;
  copyValue?: string;
  testId?: string;
};

const DETAIL_PLACEHOLDER = '-';

export const Detail = ({
  title,
  detail = DETAIL_PLACEHOLDER,
  showCopy = false,
  copyValue,
  testId,
}: Props) => {
  // some node properties return empty string, so we need to fallback to the placeholder
  const detailWithFallback = detail || DETAIL_PLACEHOLDER;

  const shouldShowCopy = showCopy && !!copyValue;

  return (
    <Stack
      direction="row"
      gap={24}
      alignItems="center"
      justifyContent="space-between"
      data-testid={testId}
    >
      <Typography
        variant="L10R"
        color="textSecondary"
        textTransform="uppercase"
        sx={{ whiteSpace: 'nowrap' }}
      >
        {title}
      </Typography>
      <Stack
        direction="row"
        alignItems="center"
        gap={4}
        justifyContent="flex-end"
        minWidth={0}
      >
        <EllipsisWithTooltip
          TooltipProps={{
            title: detailWithFallback,
            arrow: true,
            placement: 'top',
          }}
        >
          {detailWithFallback}
        </EllipsisWithTooltip>

        {shouldShowCopy && (
          <CopyToClipboard
            text={copyValue}
            iconSize={16}
            sx={{ flexShrink: 0 }}
          />
        )}
      </Stack>
    </Stack>
  );
};

const DetailSkeleton = () => {
  return (
    <Detail
      title={<Skeleton variant="text" width={100} />}
      detail={<Skeleton variant="text" width={130} />}
    />
  );
};

Detail.Skeleton = DetailSkeleton;
